( function( $ ) {	

	window.lafMagScrollTop = window.lafMagScrollTop ? window.lafMagScrollTop : {};
	const LMST = window.lafMagScrollTop;
	
	LMST.headerScrollDelay; // Init header setTimeout variable
	LMST.headerScrollEndDelay; // Init header animation end setTimeout variable
	LMST.scrollTriggerDistance = 100; // Distance from top that needs to be scrolled to trigger initial animations
	LMST.scrollTriggerRestDistance = 50; // Distance from top that needs to be scrolled to trigger restoration animations
	LMST.scrollTriggerDelay = 0; // How long after scrolling until the animation begins
	LMST.animationClassDelay = 450; // How long until the animation kicks in
	LMST.headerIsAnimating = false;
	LMST.homeWasScrolled = false;
	LMST.homeScrollCalled = false; // Check if the page was rescrolled
	LMST.scrollTop = 0;

	LMST.init = function(){

		// Window On Load functions
		$(window).on('load', function (e) {
			LMST.scrollTop = $(window).scrollTop();
			
			if( LMST.scrollTop > LMST.scrollTriggerDistance ) {
				addPageScrollClasses();
				addHomeScrollClasses( true );
			}

			// Bind scroll function to trigger header animations
			$(window).scroll(function() {
				LMST.scrollTop = $(window).scrollTop();

				if( LMST.scrollTop > LMST.scrollTriggerDistance ) {
					if( ! LMST.homeWasScrolled ) {
						addHomeScrollClasses( true );
					}					
					addPageScrollClasses();
				} else if( LMST.scrollTop == 0 ) {

					if( LMST.homeWasScrolled ) {
						removeHomeScrollClasses();
					}					
					removePageScrollClasses();
				}				
			} );

		});

		function addHomeScrollClasses( doAnimation ) {

			$('body').removeClass('lafmag-home-scroll-onload');

			if( doAnimation ) {
				if( LMST.headerIsAnimating === false ) {

					$('body').addClass('lafmag-scroll-init');
					LMST.headerIsAnimating = true;
	
					LMST.headerScrollDelay = setTimeout( function(){
						$('body').addClass('lafmag-home-scrolled');
	
						LMST.headerScrollEndDelay = setTimeout( function(){
							LMST.headerIsAnimating = false;
							LMST.homeWasScrolled = true;

							// Check if browser was scrolled to the top during animation
							if( LMST.scrollTop === 0 ) {
								removeHomeScrollClasses();
							}
						}, LMST.animationClassDelay);	
					}, LMST.animationClassDelay);
					
					
				}
			} else {
				LMST.homeWasScrolled = true;
				$('body').addClass('lafmag-home-scroll-onload');
			}						
		}

		function removeHomeScrollClasses() {

			$('body').removeClass('lafmag-home-scroll-loaded');

			if( LMST.headerIsAnimating === false ) {

				LMST.headerIsAnimating = true;
				$('body').addClass('lafmag-home-init-restore');
				
				LMST.headerScrollDelay = setTimeout( function(){
					$('body').addClass('lafmag-home-finalize-restore');
					$('body').removeClass('lafmag-scroll-init lafmag-home-scrolled');
					LMST.headerScrollEndDelay = setTimeout( function(){
						LMST.headerIsAnimating = false;
						LMST.homeWasScrolled = false;
						$('body').removeClass('lafmag-home-finalize-restore lafmag-home-init-restore');

						// Check if browser was scrolled down during animation
						if( LMST.scrollTop > LMST.scrollTriggerDistance ) {
							addHomeScrollClasses( true );
						}
					}, LMST.animationClassDelay);
				}, LMST.animationClassDelay);
			}
		}

		function addPageScrollClasses() {			
			$('body').addClass('lafmag-page-scrolled');
		}

		function removePageScrollClasses() {
			$('body').removeClass('lafmag-page-scrolled');
		}

	}
	
	// Init scroll functions
	LMST.init();
	
} )( jQuery );